// libs
import { styled } from '@nykaa/ui-components';

// constants
import { BREAKPOINTS } from 'shared/styles/base';

export const PdpWrapper = styled.div`
  word-break: break-word;
  max-width: 860px;
  margin: 0 auto ${({ theme }) => theme.spacing.spacing80};
  padding: ${({ theme }) => theme.spacing.spacing0};
  ${({ theme }) => theme.typography.bodyMedium};

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    padding-left: ${({ theme }) => theme.spacing.spacing120};
    margin-left: ${({ theme }) => theme.spacing.spacing100};
    ${({ theme }) => theme.typography.bodyLarge};
  }
`;

export const PdpSection = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.spacing160};
`;

export const PdpSectionTitle = styled.h3`
  ${({ theme }) => theme.typography.titleSmall};
  font-weight: 700;
  margin: 0 0 ${({ theme }) => theme.spacing.spacing50} 0;
  color: ${({ theme }) => theme.colors.textPrimary};
`;

export const FaqItem = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.spacing100};

  &:last-child {
    margin-bottom: ${({ theme }) => theme.spacing.spacing0};
  }
`;

export const FaqQuestion = styled.span`
  display: block;
  margin-bottom: ${({ theme }) => theme.spacing.spacing20};
  color: ${({ theme }) => theme.colors.textPrimary};
  ${({ theme }) => theme.typography.bodyMedium};
  font-weight: 700;
  @media (max-width: ${BREAKPOINTS.DESKTOP}px) {
    ${({ theme }) => theme.typography.bodyMedium};
    font-weight: 700;
  }
`;

export const FaqAnswer = styled.p`
  margin: ${({ theme }) => theme.spacing.spacing0};
  color: ${({ theme }) => theme.colors.textSecondary};
`;
